import {ref} from "vue";

import type {NotificationType} from "@songfinch/types";

import {normalizeError} from "@songfinch/utils/src/error";

const notification = ref<NotificationType | null>(null);

type RawNotificationType =
  | { text: string; error?: never; heading?: string }
  | { error: unknown; text?: never; heading?: string };


export function useNotification() {
    const normalizeNotification = (newNotification: RawNotificationType) => {
        // Type is inerpolated from if notification has error or not
        const notification: NotificationType = {
            type: "success",
            heading: newNotification.heading,
            text: newNotification.text || "",
        };

        if (newNotification.error) {
            notification.type = "error";
            notification.text = normalizeError(newNotification.error);
        }

        return notification;
    };

    const setNotification = (newNotification: RawNotificationType) => {
        notification.value = normalizeNotification(newNotification);

        setTimeout(() => {
            notification.value = null;
        }, 10000);
    };

    const clearNotification = () => {
        notification.value = null;
    };

    return {
        notification,
        setNotification,
        clearNotification,
    };
}
